module.exports = __webpack_public_path__ + "img/14-1.6e7a3aea.jpeg";